import React, { useState, useEffect } from 'react'
import { Card, Button, Table, Badge } from 'react-bootstrap'
import { toast } from 'react-toastify'
import TableIndexCreateForm from './TableIndexCreateForm'

const TableIndexes = (props) => {
    const [indexes, setIndexes] = useState([])
    const [loading, setLoading] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)

    useEffect(() => {
        if (props.tableId) {
            fetchTableIndexes()
        }
    }, [props.tableId])

    const fetchTableIndexes = async () => {
        setLoading(true)
        try {
            // TODO: Replace with actual API call when backend supports indexes
            // For now, we'll show a placeholder message
            setIndexes([])
        } catch (error) {
            console.error('Error fetching table indexes:', error)
            toast.error('Failed to fetch table indexes')
        } finally {
            setLoading(false)
        }
    }

    const handleCreateIndex = () => {
        setShowCreateForm(true)
    }

    const handleCreateSuccess = () => {
        // Refresh the indexes list after successful creation
        fetchTableIndexes()
        toast.success('Index created successfully!')
    }

    const getIndexesList = () => {
        return (
            <Card>
                <Card.Body className="p-0">
                    <div className="row">
                        <div className="col-12 table-info">
                            <div className="d-flex justify-content-center position-relative me-2">
                                <h5 className="d-inline-block m-0">Table {props.tableName} Indexes</h5>
                                <button
                                    type="button"
                                    className="btn btn-primary border-0 new-attribute-btn"
                                    onClick={handleCreateIndex}
                                >
                                    Create Index
                                </button>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            {loading ? (
                                <div className="text-center p-4">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : indexes.length === 0 ? (
                                <div className="text-center p-4">
                                    <div className="text-muted">
                                        <i className="fas fa-database fa-3x mb-3"></i>
                                        <h5>No Indexes Found</h5>
                                        <p>This table doesn't have any custom indexes yet.</p>
                                        <p className="small text-muted">
                                            Database indexes will be displayed here once the backend supports index management.
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Index Name</th>
                                            <th>Columns</th>
                                            <th>Type</th>
                                            <th>Unique</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {indexes.map((index, idx) => (
                                            <tr key={idx}>
                                                <td>{index.name}</td>
                                                <td>
                                                    {index.columns.map((col, colIdx) => (
                                                        <Badge key={colIdx} bg="secondary" className="me-1">
                                                            {col}
                                                        </Badge>
                                                    ))}
                                                </td>
                                                <td>{index.type}</td>
                                                <td>
                                                    <Badge bg={index.unique ? "success" : "secondary"}>
                                                        {index.unique ? "Yes" : "No"}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Badge bg="success">Active</Badge>
                                                </td>
                                                <td>
                                                    <Button variant="outline-danger" size="sm">
                                                        <i className="fas fa-trash"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        )
    }

    return (
        <>
            {getIndexesList()}
            <TableIndexCreateForm
                show={showCreateForm}
                onClose={() => setShowCreateForm(false)}
                tableId={props.tableId}
                tableName={props.tableName}
                onSuccess={handleCreateSuccess}
            />
        </>
    )
}

export default TableIndexes
